export default __webpack_public_path__ + "assets/ico_code-ed6e2768.svg";